import * as React from "react"
import { Consumer } from "@kiwicom/nitro/lib/services/modal/context"

import Core from "./components/Core"

const NitroSideEffects = () => <Consumer>{({ value }) => <Core modal={value} />}</Consumer>

export default NitroSideEffects
